export const calcBaseUrl = (imagesEndpoint: string, uuid: string) => {
  return `${imagesEndpoint}/images/${calcBasePath(uuid)}`;
};

// This method assumes that the base image is a jpg, which won't work for images with transparency. This is because, for transparent images, we should not use the base image
export const calcBasePath = (uuid: string) => {
  return `${uuid}/base/${uuid}.jpg`;
};
